// AngularJS core exposes itself only as the `window.angular` global (no
// module.exports). This shim loads it for that side effect and re-exports the
// global so webpack's ProvidePlugin can hand the real `angular` object to every
// module as an ambient `angular`.
require('../../bower_components/angular/angular.js');
module.exports = window.angular;
